import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  baseUrl: string | undefined;
  private httpClient: HttpClient;
  constructor(private http: HttpClient, handler: HttpBackend){
    this.httpClient = new HttpClient(handler);
}
updateFeedback(questionId: number, like: boolean): Observable<any> {
  const body = { question_id: questionId, like: like };
  return this.http.post(environment.mainApi +'question/feedback', body);
}

getFeedback(questionId: number): Observable<any> {
  const url = `${environment.mainApi}question/feedback/${questionId}`;
  return this.http.get(url);
}

increaseViewCount(questionId: number): Observable<any> {
  const url = `${environment.mainApi}question/increseView`;
  const body = { question_id: questionId };
  return this.http.post(url, body);
}

getTopViewedQuestions(limit: number = 10,collectionName:string): Observable<any> {
  const url = `${environment.mainApi}question/topViewedQuestions?limit=${limit}&collectionName=${collectionName}`;
  return this.http.get(url);
}
getversionAns(id:number):Observable<any> {
  const url = `${environment.mainApi}canned/versions/${id}`;
  return this.http.get(url);
}


getQnById(body:any):Observable<any>{
  return this.http.post(`${environment.mainApi}question/getQuestion`,body)
}
updatequesAnswer(payload:any):Observable<any>{
  return this.http.put(`${environment.mainApi}update-saved-question-answer`,payload)
}
getSimilarQuestions(collectionId: number, questionId: number, page: number , limit: number = 5): Observable<any> {
  const url = `${environment.mainApi}similar/mapped/questions?collection_id=${collectionId}&question_id=${questionId}&page=${page}&limit=${limit}`;
  return this.http.get(url);
}
faqssearch(payload:any):Observable<any>{
  return this.http.post(`${environment.mainApi}faq/search`,payload)
}
updateMappedAnswer(payload:any):Observable<any>{
  return this.http.put(`${environment.mainApi}update/canned/question/mapping`,payload)
}
}

